import { render } from "./WalletExchangeTransferDetails.vue?vue&type=template&id=2290e579&scoped=true"
import script from "./WalletExchangeTransferDetails.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTransferDetails.vue?vue&type=script&lang=js"

import "./WalletExchangeTransferDetails.vue?vue&type=style&index=0&id=2290e579&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2290e579"]])

export default __exports__